import { FaCheck } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { achievementsMilestoneIcons } from '../icons/AchievementsMilestoneIcons'
import LeadershipSectionLabel from '../leadership/LeadershipSectionLabel'
import { achievementsMilestonesSection } from '../../data/achievementsPageData'

function AchievementsMilestonesSection() {
  const { label, titleLine1, titleAccent, description, milestones } = achievementsMilestonesSection

  return (
    <AnimatedSection className="achievements-milestones" id="achievements-milestones">
      <div className="container corp-container">
        <header className="achievements-milestones__head">
          <LeadershipSectionLabel variant="red">{label}</LeadershipSectionLabel>
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
          <p>{description}</p>
        </header>

        <div className="achievements-milestones__grid" role="list">
          {milestones.map((milestone) => {
            const Icon = achievementsMilestoneIcons[milestone.icon]
            return (
              <article className="achievements-milestone-card" key={milestone.id} role="listitem">
                <div className="achievements-milestone-card__top">
                  <span className="achievements-milestone-card__icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <span className="achievements-milestone-card__badge">{milestone.number}</span>
                </div>
                <h3>{milestone.title}</h3>
                <span className="achievements-milestone-card__accent" aria-hidden="true" />
                <p>{milestone.description}</p>
                <ul>
                  {milestone.highlights.map((item) => (
                    <li key={item}>
                      <FaCheck aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default AchievementsMilestonesSection
